module.exports = __webpack_public_path__ + "img/Adriana_Lipzstein.fbd5281e.png";